import React, { useEffect, useState } from "react";
import { useAdvancedValidation } from "hooks/useAdvancedValidation";
import MessageSnackBar from "components/widgets/message-snackbar/MessageSnackBar";
import { storeData } from "../../../utility";
import { checkTimeZone } from "../../../utility/deviceDetailUtils";
import { useDispatch } from "react-redux";
import alerts from "../../../constants/alerts";
import keys from "../../../constants/keys";
import MainLayout from "components/layout/main-layout/MainLayout";
import CustomSelectBox from "components/widgets/custom-select-box/CustomSelectBox";
import { useHistory } from "react-router-dom";
import { titles } from "constants/titles";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { setCurrentTimeZone } from "redux/Common/action";
import "./TimeZoneSettings.css";

const timeFormatList = [
  { label: "24 Hours", value: "24", id: 1 },
  { label: "12 Hours", value: "12", id: 2 },
];

const timeZoneList = [
    { label: "Phone Timezone", value: "device", id: 1 },
    { label: "Protected Address Timezone", value: "medical", id: 2 },
  ];

const TimeZoneSettings = () => {
  const [selectedValue, setSelectedValue] = useState(timeZoneList?.[0]);
  const [selectedTimeFormat, setSelectedTimeFormat] = useState(timeFormatList?.[1]);
  const history = useHistory();
  const dispatch = useDispatch();

  // Initialize validation hook
  const { onApiResponse, snackbarState, dismissSnackbar } = useAdvancedValidation();

  useEffect(() => {
    getCurrentTimeZoneData();
  }, []);

  const handleDropdownSelect = (value) => {
    setSelectedValue(value);
  };
  const handleDropdownSelectTimeZone = (value) => {
    setSelectedTimeFormat(value);
  };

  const onSaveClick = () => {
    if (!selectedValue || !selectedTimeFormat) {
      return;
    }
    const updateSettings = {
      timezone: selectedValue?.value === "medical",
      format: selectedTimeFormat?.value === "12",
    };

    storeData(keys?.timeZoneSettings, JSON.stringify(updateSettings));
    setCurrentTimeZone(dispatch, JSON.stringify(updateSettings));
    onApiResponse(alerts?.timezone_settings_updated, "success");
    setTimeout(() => {
      history?.goBack();
    }, 1000);
  };

  const getCurrentTimeZoneData = async () => {
    const localData = await checkTimeZone();
    if (localData) {
      // format: true means 12 hours, false means 24 hours
      setSelectedTimeFormat(localData?.format ? timeFormatList?.[1] : timeFormatList?.[0]);
      setSelectedValue(localData?.timezone ? timeZoneList?.[1] : timeZoneList?.[0]);
    } else {
      // Default to 12 hours format when no data exists
      setSelectedTimeFormat(timeFormatList?.[1]);
      setSelectedValue(timeZoneList?.[0]);
    }
  };

  return (
    <>
      <MessageSnackBar
        message={snackbarState.message}
        isVisible={snackbarState.show}
        onDismiss={dismissSnackbar}
        type={snackbarState.type}
        autoHideDuration={snackbarState.autoHideDuration}
      />
      <MainLayout
        text="Time Zone"
        isBackHide={false}
        isNavbar={false}
        
      >
        <div className="timezone_container">
          <p className="timezone_title">
            {titles?.timezone_time_format}
          </p>
          <CustomSelectBox
            selectedValue={selectedValue?.value}
            onChange={handleDropdownSelect}
            options={timeZoneList}
            title={titles?.select_issue_type}
            className={"cs_select_dropdown mb24"}
          />
          <p className="timezone_title">
            {titles?.timeFormat}
          </p>
          <CustomSelectBox
            selectedValue={selectedTimeFormat?.value}
            onChange={handleDropdownSelectTimeZone}
            options={timeFormatList}
            title={titles?.select_issue}
            className={"cs_select_dropdown"}
          />
          <div className="timezone_button_container">
            <CustomButton
              width={"100%"}
              text={titles?.save_changes}
              onClick={() => onSaveClick()}
            />
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default TimeZoneSettings;
